import React from "react";

const Lifecycle = () => {
  return (
    <div>
      <div className="max-w-screen flex flex-col justify-center items-center pb-40 px-14">
        <div
          className="w-full bg-cover bg-center mt-32 mb-20 rounded-[50px]"
          style={{ backgroundImage: 'url("/lifecycle.svg")' }}
        >
          <div className=" flex flex-col justify-center items-center">
            <div className="lg:w-3/5">
              <p className="text-4xl lg:text-5xl px-14 lg:px-0 mt-36 font-bold text-white text-center my-0">
                An End-To-End Software Lifecycle
              </p>
              <p className="text-lg lg:text-xl font-medium text-white text-center py-8 px-14 lg:px-0">
                We ideate, design, develop, market and maintain all our
                software. No third-party interference. Just pure, undiluted
                creativity and engineering. We follow our own software
                development methodology which incorporates speed, adaptability
                and above all, the capability to deliver feature-rich products
                swiftly.
              </p>
            </div>
          </div>
        </div>
        <div className="w-full flex justify-center items-center">
          <img src="/map.svg" alt="map" className="max-w-full" />
        </div>

        <div className="w-full pt-20">
          <div className="flex justify-center items-center">
            <div className="flex flex-col justify-center items-center md:w-3/5 gap-10">
              <p className="text-5xl md:text-6xl font-bold font-syne my-0 text-center">
                Get in touch
              </p>
              <p className="flex text-xl my-0 font-medium text-center">
                Interested in elevating your business or personal life with Idia
                Corporation's software? Contact us to discover more about our
                innovative products and how they can help you achieve your
                goals. Together, let's unlock the future of technology and
                explore new possibilities for success.
              </p>
              <a
                href="#"
                className="text-2xl lg:text-3xl font-bold text-[#1378E3]"
              >
                hello@idiacorp.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Lifecycle;
